/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_Col_CurrencyInputs */

const en_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

const de_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währung`)
};

const fr_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devise`)
};

const es_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moneda`)
};

const it_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuta`)
};

const nl_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuta`)
};

const pl_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waluta`)
};

const fi_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuutta`)
};

const da_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuta`)
};

const sv_salary_compare_col_currency = /** @type {(inputs: Salary_Compare_Col_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuta`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Salary_Compare_Col_CurrencyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_col_currency = /** @type {((inputs?: Salary_Compare_Col_CurrencyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_Col_CurrencyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_col_currency(inputs)
	if (locale === "fr") return fr_salary_compare_col_currency(inputs)
	if (locale === "es") return es_salary_compare_col_currency(inputs)
	if (locale === "it") return it_salary_compare_col_currency(inputs)
	if (locale === "nl") return nl_salary_compare_col_currency(inputs)
	if (locale === "pl") return pl_salary_compare_col_currency(inputs)
	if (locale === "fi") return fi_salary_compare_col_currency(inputs)
	if (locale === "da") return da_salary_compare_col_currency(inputs)
	if (locale === "sv") return sv_salary_compare_col_currency(inputs)
	return en_salary_compare_col_currency(inputs)
});